import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { IHeader, ITableData, IText, TableData } from './table-data.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CbicContentMst, ICbicContentMst } from '../../cbic-content-mst.model';
import { UtilsService } from 'app/core/util/view-file.component';
import { ViewContentComponent } from '../view-content.component';
import { ICbicDocMst } from 'app/entities/cbic-doc-mst/cbic-doc-mst.model';
import { ChangeLanguageService } from 'app/core/util/change-language.service';
import { CbicContentMstService } from '../../service/cbic-content-mst.service';
import { HttpResponse } from '@angular/common/http';
import { ContentNavigationService } from '../services/content-navigation.service';
import { NgIfContext } from '@angular/common';

@Component({
  selector: 'cbic-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css'],
})

export class TableComponent implements OnInit {
  @Input() data?: ICbicContentMst;

  @Input() linkUrl?: boolean | null;

  pageControlsId = (Math.random() + Date.now()).toString();
  currentPage = 1;
  pageSize = 10;
  totalRecords = 0;
  tableSizes = [10, 20, 50, 100, 200, 500];
  downloadLabel: IText = { En: "Link/Download", Hi: "Link/Download" };
  tableData?: ITableData;
  contentData?: any;
  parentData?: any;
  category = [16410, 16411, 30604, 30607];
  searchText: any = '';
  years: any;



  public topNavigationService!: ContentNavigationService;
  router: any;
  selectedYear: any;




  constructor(
    private modalService: NgbModal,
    private changeLnService: ChangeLanguageService,
    public utils: UtilsService,
    private contentMstService: CbicContentMstService) {
    this.getUploadPeriod();
  }

  public serviceGetUploadPeriod() {
    const baseYear = 2018;
    const currYear = new Date().getFullYear();
    const years = [];
    // const years= [];

    for (let i = baseYear; i <= currYear; i++) {
      //years.push(i);commented for stopping duplicacy 
      years.push(i);
    }
    return years.reverse();
  }

  getUploadPeriod() {
    this.years = this.serviceGetUploadPeriod();
    //console.log(this.years);
  }
  ngOnInit(): void {
    //console.log("intialisedcalled");
    //code for no record found code start
    this.selectedYear.valueChanges.subscribe((_value: any) => {
      if (!_value) {
        console.log(_value);
        this.selectedYear.setErrors({
          required: true

        });
      }
    });
  }


  getTableInfo(): ITableData | undefined {

    if (this.data && (!this.tableData || this.tableData.id !== this.data.id)) {
      this.tableData = new TableData(new Array<IHeader>(), this.data.id, new Array<any>())
      const tableConfigs = this.data.tableViewConfigs;
      if (tableConfigs && tableConfigs.length > 0) {
        const headers = new Array<IHeader>();
        tableConfigs.forEach((currVal) => {
          headers.push({
            title: { En: currVal.titleEn ?? "", Hi: currVal.titleHi ?? "" },
            dataKey: { En: currVal.valColumnEn?.trim() ?? "", Hi: currVal.valColumnHi?.trim() ?? "" },
            style: currVal.colStyle ?? "",
            displayTextLimit: currVal.displayTextLimit
          });
        });
        this.tableData.headers = headers;
      } else {
        this.tableData.headers = [{
          title: { En: "Subject", Hi: "Subject" },
          dataKey: { En: "titleEn", Hi: "titleHi" },
          style: "",
          displayTextLimit: 0
        }];
      }
      this.tableData.setBody(this.data?.childContentList ?? []);
      this.totalRecords = this.tableData.body.length;
      this.currentPage = 1;
      this.pageSize = 10;
    }
    this.parentData = this.tableData?.id;


    if (!this.category.includes(this.parentData)) {

      this.searchText = "";
    }


    return this.tableData;
  }


  showMoreContent(parentId: number) {
    const modelContent = this.tableData?.body?.filter((val: any) => val.id === parentId);
    if (modelContent && modelContent.length > 0) {
      const modelRef = this.modalService.open(ViewContentComponent,
        { modalDialogClass: 'custom-dialog modal-dialog-centered modal-lg', size: 'lg' });
      //console.log(modelContent[0]);
      modelRef.componentInstance.cbicContentMst = modelContent[0];
      modelRef.componentInstance.showClose = true;
      modelRef.componentInstance.isBreadcrumb = false;
      modelRef.componentInstance.modelRef = modelRef;

    }
  }

  onTableDataChange(page: any): any {
    this.searchText = "";
    this.currentPage = page;
  }

  ontableSizeChange(event: any): void {
    this.pageSize = event.target.value;
    this.currentPage = 1;
  }

  onYearChange(event: any): void {
    this.pageSize = event.target.value;
    this.currentPage = 1;
  }

  viewFile(doc: ICbicDocMst) {
    let filePath = doc.filePathEn;
    if (this.changeLnService.getLanguage() === 'hi' && doc.filePathHi) {
      filePath = doc.filePathHi;
    }
    this.utils.viewOpenning(filePath ?? "");
  }

  getNewsAndMedia(contentId: any): void {
    this.contentMstService.getNewsAndMediaData(contentId, 0, 10000).subscribe((res) => {
      if (res) {
        // const data: ICbicContentMst = res;
        this.data = res;
        this.contentData = this.data?.parentId
        //this.topNavigationService.updateNavigator(this.data);
        // this.parentFun.emit(this.data);
        // console.log(this.contentData);
      }
    });
  }

  hasInfo(content: CbicContentMst): boolean {
    if (this.changeLnService.getLanguage() === 'hi' && content.infoHi) {
      return true;
    } else if (content.infoEn) {
      return true;
    }
    return false;
  }
  getparentId(contentId: any): void {
    this.contentMstService.getNewsAndMediaData(contentId, 0, 10000).subscribe((res) => {
      if (res) {
        // const data: ICbicContentMst = res;
        this.data = res;
        this.parentData = this.data?.parentId
        //this.topNavigationService.updateNavigator(this.data);
        // this.parentFun.emit(this.data);

      }
    });
  }







  // }




}
